const PaginationButton = ({ number = 1, isSelected=false, onClick = () => { } }) => (
  <div className={`pagination-button ${isSelected && 'selected'}`} onClick={onClick}>{number}</div>
)
export default PaginationButton;